import { OPEN_SB_BTNS } from './sidebar-shopping';

const axios = require('axios');
const form = document.querySelector('form.js-product-detail');
const EDIT_BTNS = document.querySelectorAll('.js-edit-btn');
const CANCEL_BTNS = document.querySelectorAll('.js-cancel-btn');
const ORDERS = document.querySelectorAll('.c-cart__item__input');

export function init_add_to_cart() {

    if (! form) {
        return;
    }

    form.addEventListener('submit', submitToCard);
}

export function init_edit_qty() {

    if (! EDIT_BTNS) {
        return;
    }

    EDIT_BTNS.forEach(EDIT_BTN => {
        EDIT_BTN.addEventListener('click', openEditHandler)
    })

    if (! CANCEL_BTNS) {
        return;
    }

    CANCEL_BTNS.forEach(CANCEL_BTN => {
        CANCEL_BTN.addEventListener('click', closeEditHandler)
    })
}

function submitToCard(event)
{
    event.preventDefault();

    var data = serialize(form);

    axios({
        method: form.getAttribute('method') ? form.getAttribute('method') : 'GET',
        url: form.getAttribute('action') ? form.getAttribute('action') : window.location.href,
        data: data,
        headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
        .then(replaceCart)
        .catch(function (error) {
            console.error('Cart submit failed', error);
            var body = error && error.response ? error.response.data : null;
            if (body && body.errors && Object.keys(body.errors).length) {
                showCartErrors(body.errors);
                return;
            }
            var msg = (body && (body.message || body.error)) || (error && error.message) || 'Er is iets mis gegaan, probeer het later nog eens';
            alert(msg);
        });
}

function showCartErrors(errors)
{
    var container = form.querySelector('.js-cart-actions');
    if (! container) return;

    Object.keys(errors).forEach(function (key) {
        var messages = errors[key];
        if (! Array.isArray(messages)) messages = [messages];
        for (var i = 0; i < messages.length; i++) {
            var node = document.createElement('span');
            node.innerText = messages[i];
            container.appendChild(node);
        }
    });
}

function replaceCart(response)
{
    // Commerce 5: a 2xx response means success. Errors come back as 4xx in .catch.
    // If the body still carries `errors`, surface them.
    if (response.data && response.data.errors && Object.keys(response.data.errors).length) {
        showCartErrors(response.data.errors);
        return;
    }

    axios.get(window.location.href)
        .then(function (response) {
            const CLASSNAME = '.js-shopping-cart .js-cart-body';

            let cart = document.querySelector(CLASSNAME);
            let dom = document.createElement('html');
            dom.innerHTML = response.data;

            cart.innerHTML = dom.querySelector(CLASSNAME).innerHTML;

            OPEN_SB_BTNS[0].click();
        });
}

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
var serialize = function (form) {

    // Setup our serialized data
    var serialized = [];

    // Loop through each field in the form
    for (var i = 0; i < form.elements.length; i++) {

        var field = form.elements[i];

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        // Convert field data to a query string
        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
        }
    }

    return serialized.join('&');

};

function openEditHandler(e) {
    const SELECTED_ITEM_ID = e.target.dataset.itemId
    ORDERS.forEach(ORDER => {
        if (ORDER.dataset.itemId == SELECTED_ITEM_ID) {
            ORDER.classList.add('in-edit-mode')
        }
    })
}

function closeEditHandler(e) {
    const SELECTED_ITEM_ID = e.target.dataset.itemId
    ORDERS.forEach(ORDER => {
        if (ORDER.dataset.itemId == SELECTED_ITEM_ID) {
            ORDER.classList.remove('in-edit-mode')
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/scripts/cart.js